// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder {
  position: relative;
  transition: 1s;
}

.panel-container {
  position: absolute;
  height: calc(100% - 16px);
  transition: 1s;
  background-color: rgba(255, 255, 255, 0.9) !important;
  z-index: 100;
  border: 0px;
}

.panel-header-light {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  color: var(--ion-color-primary);
  padding: 18px 18px 18px 6px;
  margin: 0px 9px 0px 0px;
  -webkit-user-select: none;
          user-select: none;
}
.panel-header-light fa-icon {
  font-size: 20px !important;
  padding-right: 11px;
  padding-left: 3px;
}

.panel-header-dark {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  background-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  padding: 14px;
  margin: 0px;
  border-radius: 16px 0px 0px 0px;
  -webkit-user-select: none;
          user-select: none;
}
.panel-header-dark fa-icon {
  font-size: 18px !important;
  padding-right: 8px;
  padding-left: 8px;
}

.panel-content {
  height: calc(100% - 42px);
  padding: 0px;
  overflow-y: auto;
  -webkit-user-select: none;
          user-select: none;
}

.panel-handle {
  position: absolute;
  width: 22px;
  opacity: 0.8;
  transition: 1s;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  background-color: var(--ion-color-primary);
  z-index: 100;
}
.panel-handle fa-icon {
  position: absolute;
  font-size: 18px !important;
  color: var(--ion-color-primary-contrast);
}

.panel-handle-left {
  border-radius: 0px 12px 12px 0px;
  box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.2);
}
.panel-handle-left fa-icon {
  right: 5px;
}

.panel-handle-left:hover {
  width: 32px !important;
  background-color: var(--ion-color-dark) !important;
  cursor: pointer;
  opacity: 1 !important;
}

.panel-handle-right {
  left: -22px !important;
  border-radius: 12px 0px 0px 12px;
  box-shadow: -6px 6px 12px rgba(0, 0, 0, 0.2);
}
.panel-handle-right fa-icon {
  left: 5px;
}

.panel-handle-right:hover {
  left: -32px !important;
  width: 32px !important;
  background-color: var(--ion-color-dark) !important;
  cursor: pointer;
  opacity: 1 !important;
}

/* for Chrome, Safari, and Opera */
.panel-content::-webkit-scrollbar {
  width: 6px;
}

.panel-content::-webkit-scrollbar-track {
  background: transparent;
}

.panel-content::-webkit-scrollbar-track:hover {
  background: transparent;
}

.panel-content::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 6px;
}

.panel-content::-webkit-scrollbar-thumb:hover {
  background: #8e8e8e;
}

.panel-content.inner-scroll {
  scrollbar-width: thin;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components/side-panel/side-panel/side-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,qDAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AAAE;EACE,0BAAA;EACA,mBAAA;EACA,iBAAA;AAEJ;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,wCAAA;EACA,aAAA;EACA,WAAA;EACA,+BAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AAAE;EACE,0BAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;AACF;AAAE;EACE,kBAAA;EACA,0BAAA;EACA,wCAAA;AAEJ;;AAEA;EACE,gCAAA;EACA,2CAAA;AACF;AAAE;EACE,UAAA;AAEJ;;AAEA;EACE,sBAAA;EACA,kDAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gCAAA;EACA,4CAAA;AACF;AAAE;EACE,SAAA;AAEJ;;AAEA;EACE,sBAAA;EACA,sBAAA;EACA,kDAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA,kCAAA;AACA;EACE,UAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,mBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;;AAHA;EACE,qBAAA;AAMF","sourcesContent":[".placeholder {\n  position: relative;\n  transition: 1s;\n}\n\n.panel-container {\n  position: absolute;\n  height: calc(100% - 16px);\n  transition: 1s;\n  background-color: rgb(255, 255, 255, 0.9) !important;\n  z-index: 100;\n  border: 0px;\n}\n\n.panel-header-light {\n  height: 42px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: bold;\n  background-color: transparent;\n  color: var(--ion-color-primary);\n  padding: 18px 18px 18px 6px;\n  margin: 0px 9px 0px 0px;\n  user-select: none;\n  fa-icon {\n    font-size: 20px !important;\n    padding-right: 11px;\n    padding-left: 3px;\n  }\n}\n\n.panel-header-dark {\n  height: 42px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  background-color: var(--ion-color-primary);\n  color: var(--ion-color-primary-contrast);\n  padding: 14px;\n  margin: 0px;\n  border-radius: 16px 0px 0px 0px;\n  user-select: none;\n  fa-icon {\n    font-size: 18px !important;\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n}\n\n.panel-content {\n  height: calc(100% - 42px);\n  padding: 0px;\n  overflow-y: auto;\n  user-select: none;\n}\n\n.panel-handle {\n  position: absolute;\n  width: 22px;\n  opacity: 0.8;\n  transition: 1s;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n  background-color: var(--ion-color-primary);\n  z-index: 100;\n  fa-icon {\n    position: absolute;\n    font-size: 18px !important;\n    color: var(--ion-color-primary-contrast);\n  }\n}\n\n.panel-handle-left {\n  border-radius: 0px 12px 12px 0px;\n  box-shadow: 6px 6px 12px rgb(0, 0, 0, 0.2);\n  fa-icon {\n    right: 5px;\n  }\n}\n\n.panel-handle-left:hover {\n  width: 32px !important;\n  background-color: var(--ion-color-dark) !important;\n  cursor: pointer;\n  opacity: 1 !important;\n}\n\n.panel-handle-right {\n  left: -22px !important;\n  border-radius: 12px 0px 0px 12px;\n  box-shadow: -6px 6px 12px rgb(0, 0, 0, 0.2);\n  fa-icon {\n    left: 5px;\n  }\n}\n\n.panel-handle-right:hover {\n  left: -32px !important;\n  width: 32px !important;\n  background-color: var(--ion-color-dark) !important;\n  cursor: pointer;\n  opacity: 1 !important;\n}\n\n/* for Chrome, Safari, and Opera */\n.panel-content::-webkit-scrollbar {\n  width: 6px;\n}\n.panel-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n.panel-content::-webkit-scrollbar-track:hover {\n  background: transparent;\n}\n.panel-content::-webkit-scrollbar-thumb {\n  background: #a1a1a1;\n  border-radius: 6px;\n}\n.panel-content::-webkit-scrollbar-thumb:hover {\n  background: #8e8e8e;\n}\n.panel-content.inner-scroll {\n  scrollbar-width: thin;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
